import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  // console.log("uid", userId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(
        `/admindashboarddata?loginid=${userId}`,
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      {/* {AdminRole.adminrole == "Admin" ? ( */}
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Subscription</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationSUB}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Subscription</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationSUB}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total EV Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's EV Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Subscription</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationSUBAmount}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Subscription</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationSUBAmount}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total EV Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's EV Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Roi Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.Roi_income}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Roi Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.Roi_income_Today}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.Level_Income}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.Level_Income_Today}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="TeamReward_income">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Salary Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.Salary_Income}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="TeamReward_income">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Salary Income</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.Salary_Income_Today}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="CTOIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Reward Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.Reward_Income}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="CTOIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Reward Income</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.Reward_Income_Today}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div> */}

                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Bonus Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Bonus Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Paid Bonus Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Paid Bonus Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawalRent}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawalRent}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Paid Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPaidWithdrawalRent}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Paid Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPaidWithdrawalRent}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Rent on Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawalRentLevel}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Rent on Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawalRentLevel}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Paid Rent on Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPaidWithdrawalRentLevel}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Paid Rent on Rent Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPaidWithdrawalRentLevel}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Net Balance</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalnetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Net Balance</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todaynetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundTransfer}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Used Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundDeduct}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Balance Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundBalance}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <>
          <div id="wrapper">
            <div class="content-page page_scroll_y">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <h3>Welcome SubAdmin </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}

export default Dashboard;
